// AGC: BaseScan utility functions for generating blockchain explorer links

/**
 * AGC: Get BaseScan URL for a contract address
 * @param address - Contract address (with or without 0x prefix)
 * @param network - Network type: 'sepolia' | 'mainnet' (default: 'sepolia')
 * @returns BaseScan URL for the contract
 */
export function getBasescanUrl(address: string, network: 'sepolia' | 'mainnet' = 'sepolia'): string {
  // AGC: Normalize address (ensure 0x prefix)
  const normalizedAddress = address.startsWith('0x') ? address : `0x${address}`
  
  // AGC: BaseScan URLs
  const baseUrl = network === 'mainnet' 
    ? 'https://basescan.org'
    : 'https://sepolia.basescan.org'
  
  return `${baseUrl}/address/${normalizedAddress}`
}

/**
 * AGC: Contract name to address mapping (for Base Sepolia)
 * AGC: Maps contract names to their addresses for automatic linking
 */
export const CONTRACT_ADDRESSES: Record<string, string> = {
  // Core Contracts
  'FarmPro Token': '0x0a862e9bE2716162f14BE1cb500b29354ED3D434',
  'OGB Token': '0x0a862e9bE2716162f14BE1cb500b29354ED3D434',
  'AirdropManager V2': '0x069CeAE653b429Bd0a397BaF4d5aCccC6dAd991a',
  'AirdropManager V3': '0x77CA54DF20eC45ae6cD4034623BD24129138E818',
  'RNG Beacon': '0xFCBbe67fA163b8526Cb6882b2b4144aF33dE3082',
  'OrigamiRngBeacon': '0xFCBbe67fA163b8526Cb6882b2b4144aF33dE3082',
  'Player XP': '0x4D8987BAAcbFeCDa9975b051A4a67737926879D5',
  'Game Treasury': '0x383352A1e8bB0B409FCc60e5eCeBAB76258cDA7c',
  
  // Battle Contracts
  'P2P Manager V2': '0xAb19009863bf91b38AEBF753172edae4dB31f283',
  'P2PBattleManagerV2': '0xAb19009863bf91b38AEBF753172edae4dB31f283',
  'PvE Manager V7': '0x4E5a5098b1eB82A9cd7C87d5d4487F8C77a8CecD',
  'PvEManagerV7': '0x4E5a5098b1eB82A9cd7C87d5d4487F8C77a8CecD',
  'Battle Bot': '0x88e1e984881CBd756a5d6B398B64d6493047b208',
  
  // NFT Contracts
  'Buff1155': '0xB9056C235C5BAE9c4eF76A6130bA670DF4e267EF',
  'Potion1155': '0x99593F655bEA59C8cc094776bCEe2C377b1c4e7a',
  'ClassicPotion1155': '0x5c51846f484Ad68df12253621188069205cFC04E',
  
  // Staking & Revenue
  'StakingManager V4': '0xbcB64EE0b6bbb49EB16C94C02B7507C65972B127',
  'StakingManager V5': '0xB5F6Dd1334d6a317Ec314820403b7f1a3fF71a65',
  'StakingRevenueShare V4': '0x8Ca66F5ba3Daa478a45814b5b59eD21750Dc1804',
  'StakingMirror': '0x0a89D5e0c759A87dB0a1Bd6EaaE81C97c3744A68',
  
  // Tournament
  'RoundRobinTournament': '0xa841f64dC0c58dCd18307C5A006Ef17C56397e41',
}

/**
 * AGC: Get contract address by name
 * @param contractName - Name of the contract
 * @returns Contract address or null if not found
 */
export function getContractAddress(contractName: string): string | null {
  return CONTRACT_ADDRESSES[contractName] || null
}

